export { default as AdminListTableItemDesktop } from './AdminListTableItemDesktop';

export type {
  AdminListTableItemDesktopProps,
  AdminListTableItemDesktopComponent,
} from './AdminListTableItemDesktop.type';
